import styled from 'styled-components';

import theme from '../../theme';

const VARIANT_COLORS = {
  error: theme.colors.error,
  warning: theme.colors.warning,
  success: theme.colors.success,
  info: theme.colors.medium_gray,
  empty: theme.colors.medium_gray,
};

// Compartilhado pelo resumo do grupo e pelos itens da lista.
export const IconWrapper = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  font-size: ${({ $size = 20 }) => $size}px;
  color: ${({ $variant }) => VARIANT_COLORS[$variant] || VARIANT_COLORS.info};
`;
